import { __extends, __assign } from 'tslib';
import * as React from 'react';
import { UitkPrimaryButton, UitkTertiaryButton } from 'uitk-react-button';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-dialog.css';
var getClassNameList = classNames.bind(styles);
var UitkDialogFooter = /** @class */function (_super) {
  __extends(UitkDialogFooter, _super);
  function UitkDialogFooter() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  UitkDialogFooter.prototype.validDialogFooterButtonTypes = function (element) {
    return element.type.displayName === 'UitkPrimaryButton' || element.type.displayName === 'UitkTertiaryButton';
  };
  UitkDialogFooter.prototype.applyFooterButtonClasses = function (element) {
    return React.cloneElement(element, __assign(__assign({}, element.props), {
      className: getClassNameList(element.props.className, UitkDialogFooter.footerButtonWrapperClassNames)
    }));
  };
  UitkDialogFooter.prototype.render = function () {
    var _a = this.props,
      buttonOne = _a.buttonOne,
      buttonTwo = _a.buttonTwo,
      buttonThree = _a.buttonThree,
      stacked = _a.stacked,
      disabled = _a.disabled,
      children = _a.children;
    var Tag1 = buttonOne && buttonOne.type === 'primary' ? UitkPrimaryButton : UitkTertiaryButton;
    var Tag2 = buttonTwo && buttonTwo.type === 'primary' ? UitkPrimaryButton : UitkTertiaryButton;
    var Tag3 = buttonThree && buttonThree.type === 'primary' ? UitkPrimaryButton : UitkTertiaryButton;
    var footerWrapperClassName = getClassNameList('uitk-dialog-footer', {
      'uitk-dialog-footer-stacked': stacked
    }, {
      'is-disabled': disabled
    });
    var footerSectionWrapperClassNames = getClassNameList('uitk-dialog-footer-section');
    var childrenToRender = children && React.Children.toArray(children).filter(this.validDialogFooterButtonTypes).slice(0, stacked ? 3 : 2).map(this.applyFooterButtonClasses);
    if (childrenToRender) {
      return React.createElement("div", {
        className: footerWrapperClassName
      }, childrenToRender.map(function (child, index) {
        return React.createElement("div", {
          className: footerSectionWrapperClassNames,
          key: "footer-button-".concat(index)
        }, child);
      }));
    }
    return React.createElement("div", {
      className: footerWrapperClassName
    }, buttonOne && React.createElement("div", {
      className: footerSectionWrapperClassNames
    }, React.createElement(Tag1, {
      disabled: buttonOne.disabled || disabled,
      onClick: disabled ? undefined : buttonOne.onClick,
      href: buttonOne.href,
      className: getClassNameList(UitkDialogFooter.footerButtonWrapperClassNames),
      "data-stid": buttonOne.stid,
      "aria-label": buttonOne.accessibilityLabel
    }, buttonOne.text)), buttonTwo && React.createElement("div", {
      className: footerSectionWrapperClassNames
    }, React.createElement(Tag2, {
      disabled: buttonTwo.disabled || disabled,
      onClick: disabled ? undefined : buttonTwo.onClick,
      href: buttonTwo.href,
      className: getClassNameList(UitkDialogFooter.footerButtonWrapperClassNames),
      "data-stid": buttonTwo.stid,
      "aria-label": buttonTwo.accessibilityLabel
    }, buttonTwo.text)), stacked && buttonThree && React.createElement("div", {
      className: footerSectionWrapperClassNames
    }, React.createElement(Tag3, {
      disabled: buttonThree.disabled || disabled,
      onClick: disabled ? undefined : buttonThree.onClick,
      href: buttonThree.href,
      className: getClassNameList(UitkDialogFooter.footerButtonWrapperClassNames),
      "data-stid": buttonThree.stid,
      "aria-label": buttonThree.accessibilityLabel
    }, buttonThree.text)));
  };
  UitkDialogFooter.displayName = 'UitkDialogFooter';
  UitkDialogFooter.defaultProps = {
    stacked: false
  };
  UitkDialogFooter.footerButtonWrapperClassNames = 'uitk-dialog-footer-button';
  return UitkDialogFooter;
}(React.Component);
export { UitkDialogFooter };